import { Backdrop, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import NoSsr from '@mui/material/NoSsr';
import React from 'react';

interface LoaderProps {}

const Loader: React.FC<LoaderProps> = () => {
  const theme = useTheme();
  return (
    <NoSsr>
      <Box
        data-test='loader-component'
        zIndex={theme.zIndex.drawer + 10}
        height='100%'
        display='flex'
        flex={1}
        alignItems='center'
        justifyContent='center'
        position='absolute'
        top={0}
        left={0}
        right={0}
        bottom={0}>
        <Backdrop /*className={classes.backdrop}*/ open={true}>
          <CircularProgress color='primary' />
        </Backdrop>
      </Box>
    </NoSsr>
  );
};

export default Loader;
